import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Scorer } from '../api/client';
import { Flag } from './TeamBadge';
import { teamName } from '../lib/flags';
import { useStore } from '../stores/store';

const Row = styled.button<{ $fav: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme, $fav }) => ($fav ? theme.colors.gold : theme.colors.border)};
  border-radius: ${({ theme }) => theme.radius};
  padding: 9px 12px;
  margin-bottom: 8px;
  text-align: left;

  .pos {
    width: 22px;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.textMuted};
    text-align: center;
  }
  .info { min-width: 0; flex: 1; }
  .nm { font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .tm { font-size: 0.78rem; color: ${({ theme }) => theme.colors.textMuted}; }
  .goals {
    margin-left: auto;
    font-weight: 800;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.colors.accent};
    white-space: nowrap;
  }
  .goals small { font-weight: 500; font-size: 0.7rem; color: ${({ theme }) => theme.colors.textMuted}; }
`;

const medal = (pos: number) => (pos === 1 ? '🥇' : pos === 2 ? '🥈' : pos === 3 ? '🥉' : String(pos));

export function ScorersList({ scorers }: { scorers: Scorer[] }) {
  const navigate = useNavigate();
  const favorite = useStore((s) => s.favorite);
  return (
    <>
      {scorers.map((s) => (
        <Row
          key={s.team + s.name}
          $fav={s.team === favorite}
          onClick={() => navigate(`/team/${encodeURIComponent(s.team)}`)}
        >
          <span className="pos">{medal(s.position)}</span>
          <Flag team={s.team} size={22} />
          <span className="info">
            <div className="nm">{s.name}</div>
            <div className="tm">{teamName(s.team)}</div>
          </span>
          <span className="goals">
            {s.goals} <small>{s.goals === 1 ? 'gol' : 'goles'}</small>
            {s.penalties > 0 && <small> · {s.penalties}p</small>}
          </span>
        </Row>
      ))}
    </>
  );
}
